import { useState } from 'react';
import { useI18n } from '@/hooks/useI18n';
import styles from './ValueFlow.module.css';

export function ValueFlow() {
  const { t } = useI18n();
  const { flow, flowStages } = t.marketing;

  // El estado guarda el `id` de la etapa, no su índice ni su título: el `id` es
  // el mismo en todos los idiomas, así que cambiar de idioma no salta de tab.
  const [activeId, setActiveId] = useState(flowStages[0].id);
  const active = flowStages.find((stage) => stage.id === activeId) ?? flowStages[0];

  return (
    <section className="ilu-section" id="flujo">
      <div className="ilu-container">
        <span className="ilu-eyebrow">{flow.eyebrow}</span>
        <h2 className="ilu-section-title">{flow.title}</h2>
        <p className="ilu-lead">{flow.lead}</p>

        <div className={styles.tabs} role="tablist" aria-label={flow.tablistLabel}>
          {flowStages.map((stage) => (
            <button
              key={stage.id}
              type="button"
              role="tab"
              id={`flujo-tab-${stage.id}`}
              aria-selected={stage.id === activeId}
              aria-controls={`flujo-panel-${stage.id}`}
              onClick={() => setActiveId(stage.id)}
            >
              {stage.step} {stage.shortLabel}
            </button>
          ))}
        </div>

        <div
          className={[styles.panel, 'animate-in'].join(' ')}
          role="tabpanel"
          id={`flujo-panel-${active.id}`}
          aria-labelledby={`flujo-tab-${active.id}`}
          key={active.id}
        >
          <div>
            <div className={styles.step}>{active.step}</div>
            <h3 className={styles.title}>{active.title}</h3>
            <div className={styles.blocks}>
              {active.blocks.map((block, i) => (
                <div key={i} className={styles.block}>
                  <h4>{block.title}</h4>
                  <p>{block.body}</p>
                </div>
              ))}
            </div>
            {active.note && <p className={styles.note}>{active.note}</p>}
          </div>

          <figure className={styles.image}>
            <img src={active.image} alt={active.imageAlt} loading="lazy" />
          </figure>
        </div>
      </div>
    </section>
  );
}
